import React from 'react'

import queryString from 'query-string'

import { AdminContext } from 'contexts/AdminContext'

import { ZariContext } from '_zari/context'
import { Portlet, Alert } from '_zari/core'

import { CodigosTransaccionesConstant, TiposDocumentoSunatConstant } from 'constants/index'

import { MovimientosTurnoModal } from 'sharedComponents/modals'

import { IdGen } from 'utils'

import * as FacturacionService from 'services/facturacion.service'

import * as Vistas from './vistas'

const VentasNuevaPage = ({ match, location }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)
  const [mostrarMovimientosTurnoModal, setMostrarMovimientosTurnoModal] = React.useState(false)

  const editarDataRef = React.useRef({})
  const flagEditarComentarios = React.useRef(false)

  const codigoTransaccion = React.useMemo(() => {
    const splitedUrl = location.pathname.split('/')
    const transaccionAndQuery = splitedUrl[1].split('?')
    const transaccion = transaccionAndQuery[0]
    return transaccion
  }, [location.pathname])

  const flagSinEntrega = React.useMemo(() => {
    return codigoTransaccion === CodigosTransaccionesConstant.VENTAS_SINENTREGA_NUEVA
  }, [codigoTransaccion])

  const flagVentaRapida = React.useMemo(() => {
    return codigoTransaccion === CodigosTransaccionesConstant.VENTASRAPIDAS_NUEVO
  }, [codigoTransaccion])

  const flagDuplicado = React.useMemo(() => {
    return match.params.tipoDocumento === 'duplicado'
  }, [match.params])

  const clickMovimientosTurno = React.useCallback(() => {
    setMostrarMovimientosTurnoModal(true)
  }, [])

  const portletBreadcrumbs = React.useMemo(() => {
    let baseName = 'Ventas'
    if (flagSinEntrega) {
      baseName += ' Sin Entrega'
    }
    if (flagVentaRapida) {
      baseName += ' Rapidas'
    }

    if (match.params.id) {
      if (match.params.tipoDocumento) {
        if (match.params.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) {
          return [
            { name: baseName, path: `/${CodigosTransaccionesConstant.VENTAS_LISTA}` },
            { name: 'Generar Nota Crédito' }
          ]
        } else if (match.params.tipoDocumento === 'duplicado') {
          return [
            { name: baseName, path: `/${CodigosTransaccionesConstant.VENTAS_LISTA}` },
            { name: 'Nuevo Duplicado' }
          ]
        }
      }

      const parsed = queryString.parse(location.search)
      flagEditarComentarios.current = !!parsed.flagEdicion

      if (flagEditarComentarios.current) {
        return [
          { name: baseName, path: `/${CodigosTransaccionesConstant.VENTAS_LISTA}` },
          { name: 'Editar Comentarios' }
        ]
      }

      return [{ name: baseName, path: `/${CodigosTransaccionesConstant.VENTAS_LISTA}` }, { name: 'Editar' }]
    }

    return [{ name: baseName, path: `/${CodigosTransaccionesConstant.VENTAS_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id, match.params.tipoDocumento, location.search, flagSinEntrega, flagVentaRapida])

  const portletButtons = React.useMemo(() => {
    if (__adminContext.valoresConfiguracionUsuario.flagAtencionIsla) {
      return [{ name: 'Movimientos del Turno', onClick: clickMovimientosTurno }]
    }
    return []
  }, [__adminContext.valoresConfiguracionUsuario.flagAtencionIsla, clickMovimientosTurno])

  React.useEffect(() => {
    if (match.params.id) {
      if (match.params.tipoDocumento) {
        if (match.params.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) {
          if (match.params.version === 'v2') {
            FacturacionService.obtenerxIdHistorialAsEdicion(match.params.id)
              .then(({ data }) => {
                const { _id, ...newData } = data

                editarDataRef.current = {
                  ...newData,
                  _idHistorialNota: match.params.id
                }

                setKeyMainForm(IdGen.newId())
              })
              .catch(({ data: { error } }) => __zariContext.snack('error', error))
          } else {
            FacturacionService.obtenerxIdAsEdicion(match.params.id)
              .then(({ data }) => {
                const { _id, ...newData } = data

                editarDataRef.current = {
                  ...newData,
                  _idDocumentoNota: _id
                }

                setKeyMainForm(IdGen.newId())
              })
              .catch(({ data: { error } }) => __zariContext.snack('error', error))
          }
        } else if (match.params.tipoDocumento === 'duplicado') {
          FacturacionService.obtenerxIdAsEdicion(match.params.id)
            .then(({ data }) => {
              const { _id, ...newData } = data

              editarDataRef.current = {
                ...newData,
                idsAnticipos: [],
                _idDireccionSocio: '',
                _idPlacaSocio: '',
                _idSocio: '',
                codigoSocio: '',
                cantidadCuotas: '',
                cuotas: null,
                documentoSocio: '',
                flagPorGuias: false,
                infosAnticipos: [],
                montoAnticipo: 0,
                nombreAlternativoSocio: '',
                nombreSocio: '',
                tipoDocumentoSocio: '',
                fechaEmision: '',
                fechaVencimiento: '',
                serieDocumento: '',
                numeroDocumento: ''
              }

              setKeyMainForm(IdGen.newId())
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      } else {
        const parsed = queryString.parse(location.search)
        flagEditarComentarios.current = !!parsed.flagEdicion
        if (location.state?.flagAnular) {
          FacturacionService.obtenerxIdAsAnular({ id: match.params.id, flagAnular: location.state.flagAnular })
            .then(({ data }) => {
              editarDataRef.current = data
              setKeyMainForm(IdGen.newId())
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        } else {
          FacturacionService.obtenerxIdAsEdicion(match.params.id)
            .then(({ data }) => {
              editarDataRef.current = data
              setKeyMainForm(IdGen.newId())
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      }
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext, location.search, location.state])

  return (
    <>
      {__adminContext.estadoTurno || !__adminContext.valoresConfiguracionUsuario.flagTurno ? (
        <Portlet>
          <Portlet.Header
            title={flagSinEntrega ? 'Ventas sin Entrega' : flagVentaRapida ? 'Ventas Rapidas' : 'Ventas'}
            breadcrumbs={portletBreadcrumbs}
            buttons={portletButtons}
          />
          <Portlet.Body>
            {__keyMainForm && (
              <>
                {__adminContext.valoresConfiguracionUsuario.flagAtencionIsla ? (
                  <Vistas.GrifoVista
                    key={__keyMainForm}
                    editarData={editarDataRef.current}
                    flagEditar={!!editarDataRef.current._id}
                    flagEditarComentarios={flagEditarComentarios.current}
                    flagSinEntrega={flagSinEntrega}
                    flagVentaRapida={flagVentaRapida}
                    codigoTransaccion={codigoTransaccion}
                    reiniciarFormulario={() => setKeyMainForm(IdGen.newId())}
                  />
                ) : (__adminContext.valoresConfiguracionUsuario.flagAkdemic ? (
                  <Vistas.AkdemicVista
                    key={__keyMainForm}
                    editarData={editarDataRef.current}
                    flagEditar={!!editarDataRef.current._id}
                    flagNota={!!editarDataRef.current._idDocumentoNota}
                    flagEditarComentarios={flagEditarComentarios.current}
                    flagSinEntrega={flagSinEntrega}
                    flagVentaRapida={flagVentaRapida}
                    flagDuplicado={flagDuplicado}
                    flagAnular={location.state?.flagAnular}
                    flagNuevaNota={match.params.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO}
                    codigoTransaccion={codigoTransaccion}
                    reiniciarFormulario={() => setKeyMainForm(IdGen.newId())}
                  />
                ) : (
                  <Vistas.EstandarVista
                    key={__keyMainForm}
                    editarData={editarDataRef.current}
                    flagEditar={!!editarDataRef.current._id}
                    flagNota={!!editarDataRef.current._idDocumentoNota}
                    flagEditarComentarios={flagEditarComentarios.current}
                    flagSinEntrega={flagSinEntrega}
                    flagVentaRapida={flagVentaRapida}
                    flagDuplicado={flagDuplicado}
                    flagAnular={location.state?.flagAnular}
                    flagNuevaNota={match.params.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO}
                    codigoTransaccion={codigoTransaccion}
                    reiniciarFormulario={() => setKeyMainForm(IdGen.newId())}
                  />
                )
                )}
              </>
            )}
          </Portlet.Body>
        </Portlet>
      ) : (
        <Alert color='danger'>Esta función requiere aperturar turno.</Alert>
      )}
      {mostrarMovimientosTurnoModal && (
        <MovimientosTurnoModal
          show={mostrarMovimientosTurnoModal}
          handleClose={() => {
            setMostrarMovimientosTurnoModal(false)
          }}
          self
        />
      )}
    </>
  )
}

export default VentasNuevaPage
